<template>
  <div>
    <modal
      v-for="(alert, index) in alerts"
      :key="index"
      :visible="true"
      :title="alert.details.title"
      transition="zoom"
      @ok="hideAlert(index)"
      @cancel="hideAlert(index)">
      <v-tabs fixed-tabs>
        <div
          v-for="(tab, key) in tabs"
          :key="key"
        >
          <v-tab v-if="!tab.debug || tab.debug == debugMode">
            {{ tab.text }}
          </v-tab>
        </div>
        <v-tab-item
          key="message"
          class="text-xs-center pa-4"
        >
          <span v-html="alert.details.message"/>
        </v-tab-item>
        <v-tab-item
          key="details"
        >
          <pre class="alert-details">{{ alert.details }}</pre>
        </v-tab-item>
        <v-tab-item
          key="request"
        >
          <pre class="alert-details">{{ alert.request }}</pre>
        </v-tab-item>
      </v-tabs>

    </modal>
  </div>
</template>

<script>
// import vuex mapping
import { mapMutations, mapGetters } from 'vuex'

// our new component
export default {
  data () {
    return {
      tabs: {
        message: {
          text: 'Message',
          debug: false
        },
        details: {
          text: 'Details',
          debug: true
        },
        request: {
          text: 'Message',
          debug: true
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      alerts: 'info/alerts',
      primaryPerson: 'person/primaryPerson'
    }),
    debugMode () {
      return this.primaryPerson && this.primaryPerson.personGroupID === '5'
    }
  },
  methods: {
    ...mapMutations({
      hideAlert: 'info/hideAlert'
    })
  }
}
</script>
<style scoped>
pre {
  height: 400px;
  width: 100%;
  overflow: scroll;
  text-align: left;
  background: black;
  color: white;
}
</style>
